import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  margin-left: ', 'px;\n'], ['\n  color: ', ';\n  margin-left: ', 'px;\n']);

import styled from 'styled-components';
import { getProvided } from '../../theme/util';
import { layout } from '../../shared-variables';

var NavigationItemCaption = styled.span(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return getProvided(theme).subText;
}, layout.padding.side);

NavigationItemCaption.displayName = 'NavigationItemCaption';
export default NavigationItemCaption;